import { render, staticRenderFns } from "./TaxReturnNav.vue?vue&type=template&id=4164312d&"
import script from "./TaxReturnNav.vue?vue&type=script&lang=ts&"
export * from "./TaxReturnNav.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports